import React from "react";
import { Header, Footer } from "../../layouts";
import ProductGrid from "../../components/products/productGrid";
import { HeroSm } from "../../components";
import { Slang } from "../../helpers";
import ProductStrength from "../../components/products/productStrength";
import ProductTop from "../../components/products/productTop";
import ProductCategories from "../../components/products/productCategories";

const MarketPlace = () => {
  const lang = Slang("navbar");

  return (
    <>
      <Header />
      <HeroSm  title="Market place " />
      {/* <div className=" content-space-t-5"> */}
        <ProductStrength />

        <ProductCategories />

        <ProductTop />

        <ProductGrid viewType="trending" limit={10} />

        <Footer />
      {/* </div> */}
    </>
  );
};

export default MarketPlace;
